import * as React from "react";
import { forwardRef } from "react";
const SvgHold = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 15, height: 16, viewBox: "0 0 15 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.5 15C0.5 15.5523 0.947715 16 1.5 16H4.5C5.05228 16 5.5 15.5523 5.5 15V1C5.5 0.447715 5.05228 0 4.5 0H1.5C0.947715 0 0.5 0.447715 0.5 1V15ZM10.5 0C9.94771 0 9.5 0.447715 9.5 1V15C9.5 15.5523 9.94772 16 10.5 16L13.5 16C14.0523 16 14.5 15.5523 14.5 15V1C14.5 0.447715 14.0523 0 13.5 0H10.5Z" }));
const ForwardRef = forwardRef(SvgHold);
export default ForwardRef;
